<template>
  <div class="dea-checkbox-list" :class="{ 'dea-checkbox-list--disabled': disabled }">
    <div class="dea-checkbox-list__label-container">
      <p class="dea-checkbox-list__label">{{ label }}</p>
    </div>
    <div class="dea-checkbox-list__list-container">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 *
 */
export default {
  name: "CheckboxList",
  status: "prototype",
  release: "1.0.0",
  props: {
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
